import { Component, OnInit, ViewChild } from '@angular/core';
import { ToastrService } from 'ngx-toastr';

// Import service
import { UserService } from '../../services/user.service';

// Import models
import { PeriodicElement, QueryParams, Sorting } from "../../models/user.model"
import { MatPaginator, PageEvent } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { Router } from '@angular/router';

// import lib
import { orderCSV, orderPDF, orderXLS } from './downloader';
import * as moment from 'moment';
import isEmpty from 'src/app/lib/validte';
import { convert } from 'src/app/lib/roundOf';
@Component({
  selector: 'app-zero_bal_passbook_issues',
  templateUrl: './zero_bal_passbook_issues.component.html',
  styleUrls: ['./zero_bal_passbook_issues.component.scss']
})
export class ZeroBalPassbookIssueComponent {

convert = convert

  dataSource: MatTableDataSource<PeriodicElement> = new MatTableDataSource()
  displayedColumns: string[] = ['createdAt','name','tableId','userCodeId','coin','prevBeforeBalance', 'beforeBalance','afterBalance','nextAfterBalance'];
  isLoading: boolean = false;
  totalRows = 0;
  pageSize = 10;
  currentPage = 0;
  pageSizeOptions: number[] = [10, 25, 50, 100, 500, 1000];

  sorting: Sorting = {};

  typeOption: string[] = [
    'all',
    'coin_deposit',
    'admin_deposit',
    'coin_withdraw',
    'fiat_deposit',
    'fiat_withdraw',
    'order_Cancel',
    'spot_limit_orderPlace_Insufficient',
    'spot_limit_balretrive_Insufficient_Limit',
    'spot_limit_balretrive_Insufficient_Market',
    'spot_market_orderPlace_Insufficient',
    'spot_market_orderPlace_limit_return',
    'spot_limit_orderPlace',
    'spot_market_orderPlace',
    'spot_market_orderPlace_market_return',
    'spot_limit_bal_retrieve',
    'spot_limit_match',
    'spot_market_bal_retrieve_buy',
    'spot_market_bal_retrieve_sell',
    'spot_market_match',
    'airdrop',
    'launchpad_trade',
    'launchpad_add'
  ];
  selectedType: string = 'all';

  queryParams:any = {
    fillter: '{}',
    sortObj: '{}',
    page: this.currentPage + 1,
    limit: this.pageSize,
    type: ''
  };

  @ViewChild(MatPaginator)
  paginator!: MatPaginator;

  constructor(
    private service: UserService,
    private toastr: ToastrService,
    private router: Router
  ) { }

  ngOnInit(): void {
    this.getData();
  }

  ngAfterViewInit() {
    this.dataSource.paginator = this.paginator;
  }

  getData(): void {
    this.isLoading = true

    // alert("saran");
    this.service.getAdminrepsort().subscribe({
      next: (v: any) => {
        console.log(v,"resp");
      },
      error: (err) => {
       console.log(err ,"errrr");
      }
    });
    
    this.service.getZeroBalPassbookIssue(this.queryParams).subscribe({
      next: async (v: any) => {
        const orderData = v.data;
        // this.dataSource = v.result.data
        const kycPromises = orderData.map((trade: any) => {

          if(trade.userId){
            this.service.getSingleKyc(trade.userId).subscribe({
              next:(v:any)=>{
                // Add the salesUserPanNumber to the current trade object
                trade.name = v.result.userId.firstName +" " +v.result.userId.lastName;
              },
              error:(err)=>{
                console.log("the data is " , err);
                
              }
            })
          }
        } );
       
  
        Promise.all(kycPromises).then(() => {
          
          
          // All KYC requests have been resolved, update the dataSource
          this.dataSource = new MatTableDataSource(orderData);
          // Set pagination details
          setTimeout(() => {
            this.paginator.pageIndex = this.currentPage;
            this.paginator.length = v.count;
          });
  
          this.isLoading = false;
        });
      },
      error: (err) => {
        this.isLoading = false

        const erros = err.error.errors
        if (!isEmpty(erros))
          this.toastr.error(erros.date)

        const filterObj = JSON.parse(this.queryParams.fillter || '{}');
        delete filterObj['sefd_createdAt'];
        this.queryParams.type = ''
        this.queryParams.fillter = JSON.stringify(filterObj);
      }
    });
  }

  onInputChange(event: Event, column: string) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.updateFilter(column, filterValue);
  }

  onOptionChange(event: any, column: string) {
    const filterValue = (event.source as HTMLSelectElement).value;
    this.updateFilter(column, filterValue);
  }

  onDateChange(event: any, column: string) {
    if (!event.value) {
      this.updateFilter(column, '');
      return
    }

    // const selectedDate: string = event.value.toISOString();
    const selectedDate: any = moment(event.value).format('YYYY-MM-DD');
    this.updateFilter(column, selectedDate);
  }

  pageChanged(event: PageEvent) {
    this.queryParams.page = event.pageIndex + 1;
    this.queryParams.limit = event.pageSize;
    this.getData()

    this.currentPage = event.pageIndex;
    this.pageSize = event.pageSize;
  }

  sortData(column: string) {
    if (this.sorting.column === column) {
      if (this.sorting.direction === 1) {
        this.sorting.direction = -this.sorting.direction;
      } else if (this.sorting.direction === -1) {
        this.sorting = {};
      }
    } else {
      this.sorting.column = column;
      this.sorting.direction = 1;
    }
    let sortObj = {};
    if (this.sorting.column) {
      sortObj = { [column]: this.sorting.direction };
    }
    this.queryParams.sortObj = JSON.stringify(sortObj)
    this.getData()
  }

  dateToDateSearch(event: any) {
    if (event.type == 'searchType') {
      this.queryParams.type = 'searchType'
      this.updateFilter(event.id, event.filterValue)
    } else if (event.type == 'clear') {
      this.queryParams.type = ''
      this.updateFilter(event.id, '')
    }
  }

  updateFilter(column: string, filterValue: string) {
    const filterKey =
      column === '_id' ? 'fid_id' + column
        : column === 'beforeBalance' || column === 'amount' || column === 'afterBalance' ? 'fn_' + column
          : column === 'createdAt' ? 'fd_' + column
            : column === 'tableId' ? 'fid' + column
              : column === 'sefd_' ? column + 'createdAt'
                : 'fs_' + column;

    const filterObj = JSON.parse(this.queryParams.fillter || '{}');
    if (filterValue !== '') {
      filterObj[filterKey] = filterValue;
    } else {
      delete filterObj[filterKey];
    }
    this.currentPage = 0;
    this.queryParams.page = 1;
    this.queryParams.limit = this.pageSize;
    this.queryParams.fillter = JSON.stringify(filterObj);
    this.getData();
  }

  handleDoc(value: any): void {
    let docType = {
      export: value,
      page: this.queryParams.page,
      limit: this.queryParams.limit,
      fillter: this.queryParams.fillter,
      sortObj: this.queryParams.sortObj
    }

    this.service.getFakePassbookListDoc(docType).subscribe(
      (response: any) => {
        // console.log(response, 'response')
        // return
        if (value === "pdf") {
          const pdfData = JSON.parse(response)
          orderPDF(pdfData.result.pdfData);
        } else if (value === "csv") {
          orderCSV(response);
        } else if (value === 'xls') {
          const xlsData = JSON.parse(response)
          orderXLS(xlsData)
        }
      }
    )
  }

}

